<template>
  <section class="solutions" id="soluciones">
    <div class="content">
      <div class="header-section">
        <div class="intro-text">
          <p>
            Conjunto de soluciones de identificación inteligente que permiten acceder de forma rápida a información
            esencial en situaciones de emergencia mediante tecnología NFC y códigos QR.
          </p>
        </div>

        <div class="title">
          <span class="light">NUESTRAS</span>
          <br />
          <span class="bold">SOLUCIONES</span>
        </div>
      </div>

      <div class="solutions-grid" ref="track" @scroll.passive="onScroll">
        <div class="solution-card" :class="{ active: currentIndex === 0 }">
          <div class="solution-icon">
            <img src="../assets/IMG/11.webp" alt="NFCare" />
          </div>
          <h2>NFCare</h2>
          <p>Pulsera con NFC y QR para <br /> acceso rápido a información médica esencial.</p>
          <button class="btn-acceder" @click="goToNFCare">ACCEDER</button>
        </div>

        <div class="solution-card" :class="{ active: currentIndex === 1 }">
          <div class="solution-icon">
            <img src="../assets/IMG/12.webp" alt="PET" />
          </div>
          <h2>PET</h2>
          <p>Collar inteligente con NFC, QR y AirTag para identificación y localización de mascotas.</p>
          <button class="btn-acceder">ACCEDER</button>
        </div>

        <div class="solution-card" :class="{ active: currentIndex === 2 }">
          <div class="solution-icon">
            <img src="../assets/IMG/13.webp" alt="SPORT" />
          </div>
          <h2>SPORT</h2>
          <p>Pulsera con NFC y QR pensada <br /> para emergencias durante <br /> actividad física.</p>
          <button class="btn-acceder">ACCEDER</button>
        </div>
      </div>

      <div class="controls">
        <button class="nav-btn" type="button" @click="prev" aria-label="Anterior">‹</button>

        <div class="dots" aria-label="Paginación">
          <span
            v-for="n in total"
            :key="n"
            class="dot"
            :class="{ active: currentIndex === (n - 1) }"
            @click="goTo(n - 1)"
          ></span>
        </div>

        <button class="nav-btn" type="button" @click="next" aria-label="Siguiente">›</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SolutionsView",
  data() {
    return {
      currentIndex: 0,
      total: 3,
    };
  },
  methods: {
    // Índice por centro (solo móvil)
    onScroll() {
      const el = this.$refs.track;
      if (!el) return;

      const isCarousel = window.matchMedia("(max-width: 767px)").matches;
      if (!isCarousel) return;

      const center = el.scrollLeft + el.clientWidth / 2;
      const cards = Array.from(el.querySelectorAll(".solution-card"));

      let best = 0;
      let bestDist = Infinity;

      cards.forEach((c, i) => {
        const cCenter = c.offsetLeft + c.offsetWidth / 2;
        const dist = Math.abs(center - cCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });

      this.currentIndex = best;
    },

    goTo(index) {
      const el = this.$refs.track;
      if (!el) return;

      const isCarousel = window.matchMedia("(max-width: 767px)").matches;
      if (!isCarousel) return;

      const cards = Array.from(el.querySelectorAll(".solution-card"));
      const target = cards[index];
      if (!target) return;

      const left = target.offsetLeft - (el.clientWidth - target.offsetWidth) / 2;
      el.scrollTo({ left, behavior: "smooth" });
      this.currentIndex = index;
    },

    prev() {
      this.goTo((this.currentIndex - 1 + this.total) % this.total);
    },

    next() {
      this.goTo((this.currentIndex + 1) % this.total);
    },

    goToNFCare() {
      window.location.href = "http://nfcare.com.co/login_usuarios.html";
    },

    syncOnResize() {
      const isCarousel = window.matchMedia("(max-width: 767px)").matches;
      if (isCarousel) this.$nextTick(() => this.goTo(this.currentIndex));
    },
  },
  mounted() {
    this.$nextTick(() => this.goTo(0));
    window.addEventListener("resize", this.syncOnResize, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.syncOnResize);
  },
};
</script>

<style scoped>
@font-face {
  font-family: "TT Chocolates Trial";
  src: url("@/assets/fonts/TT Chocolates Trial Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "TT Chocolates Trial Light";
  src: url("@/assets/fonts/TT Chocolates Trial Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

.solutions {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-margin-top: 100px;

  background-color: #050505;
  background-image: url("@/assets/IMG/NOSOTROS.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

.solutions::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 0;
}

.content {
  position: relative;
  z-index: 1;
  width: min(1200px, 92%);
  padding: 30px 0 30px;
}

.header-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(40px, 5vw, 60px);
  align-items: start;
  margin-bottom: 10px;
}

.intro-text p {
  font-family: "Exo", sans-serif;
  color: rgba(255, 255, 255, 0.85);
  font-size: clamp(14px, 1.5vw, 20px);
  font-weight: 300;
  line-height: 1.6;
  margin: 0;
  margin-top: 20px;
}

.title {
  margin: 0;
  text-align: right;
  color: #ffffff;
  font-family: "Exo", sans-serif;
  font-size: clamp(40px, 6vw, 76px);
  font-weight: 600;
  line-height: 1.05;
}
.title .light { font-weight: 300; }
.title .bold {
  font-family: "TT Chocolates Trial", sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(22px, 3vw, 48px);
  align-items: start;
  justify-items: center;
  margin-left: -60px;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

.solution-card {
  text-align: center;
  animation: fadeUp 520ms ease both;
  transition: transform 220ms ease, opacity 220ms ease;
}
.solution-card:nth-child(1) { animation-delay: 0ms; }
.solution-card:nth-child(2) { animation-delay: 90ms; }
.solution-card:nth-child(3) { animation-delay: 180ms; }

.solution-icon {
  width: clamp(240px, 26vw, 420px);
  height: clamp(180px, 18vw, 240px);
  margin: 0 auto 5px;
  position: relative;
  display: block;
}

.solution-icon img {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;

  transform: translateX(-50%);
  filter: drop-shadow(0 22px 26px rgba(0, 0, 0, 0.45));
  transition: transform 220ms ease, filter 220ms ease;
}

.solution-card:nth-child(1) .solution-icon img { transform: translateX(calc(-50% - 10px)); }
.solution-card:nth-child(2) .solution-icon img { transform: translateX(calc(-50% + 0px)); }
.solution-card:nth-child(3) .solution-icon img { transform: translateX(calc(-50% - 6px)); }

.solution-card:hover .solution-icon img {
  transform: translateX(calc(-50% - 0px)) translateY(-4px);
  filter: drop-shadow(0 28px 34px rgba(0, 0, 0, 0.55));
}
.solution-card:nth-child(1):hover .solution-icon img { transform: translateX(calc(-50% - 10px)) translateY(-4px); }
.solution-card:nth-child(2):hover .solution-icon img { transform: translateX(calc(-50% + 0px)) translateY(-4px); }
.solution-card:nth-child(3):hover .solution-icon img { transform: translateX(calc(-50% - 6px)) translateY(-4px); }

.solution-card h2 {
  margin: 10px 0 10px;
  font-family: "Exo", sans-serif;
  color: #ffffff;
  font-size: clamp(18px, 2vw, 26px);
  font-weight: 800;
}

.solution-card p {
  margin: 0 auto 18px;
  max-width: 360px;
  font-family: "Exo", sans-serif;
  color: rgba(255, 255, 255, 0.88);
  font-size: clamp(15px, 1.4vw, 19px);
  font-weight: 400;
  line-height: 1.45;
}

.btn-acceder {
  display: inline-block;
  padding: 10px 28px;
  background-color: rgba(150, 150, 150, 0.65);
  color: #000;
  font-family: "Exo", sans-serif;
  font-size: clamp(14px, 1.2vw, 16px);
  font-weight: 800;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: transform 200ms ease, background-color 200ms ease, box-shadow 200ms ease;
  letter-spacing: 0.05em;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
}
.btn-acceder:hover {
  background-color: rgba(190, 190, 190, 0.85);
  transform: translateY(-2px);
  box-shadow: 0 22px 54px rgba(0, 0, 0, 0.45);
}

.controls { display: none; }

@media (min-width: 768px) and (max-width: 1024px) {
  .solutions {
    min-height: auto;
    padding: 44px 0;
  }

  .content {
    padding: 24px 0 24px;
    width: min(1020px, 92%);
  }

  .header-section {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 28px;
  }

  .title {
    text-align: left;
    font-size: clamp(42px, 6vw, 70px);
  }

  .solutions-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 34px;
    justify-items: center;
    margin-left: 0;
  }

  .solution-card:nth-child(3) {
    grid-column: 1 / -1;
    max-width: 560px;
  }

  .solution-icon {
    width: min(520px, 92%);
    height: 220px;
  }

  .solution-card p {
    max-width: 460px;
  }
}

@media (max-width: 767px) {
  .solutions {
    min-height: auto;
    padding: 18px 0 28px;
    scroll-margin-top: 40px;
  }

  .content {
    padding: 34px 0 26px;
    width: min(980px, 94%);
  }

  .header-section {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 14px;
    margin-bottom: 16px;
  }

  .intro-text { text-align: center; }

  .title {
    text-align: center;
    font-size: clamp(30px, 10vw, 56px);
  }
  .solutions-grid {
    display: flex;
    gap: 18px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    padding: 14px calc((100vw - min(560px, 86vw)) / 2) 26px;
    align-items: center;
    margin-left: 0;
  }

  .solutions-grid::-webkit-scrollbar { height: 0; }
  .solutions-grid { scrollbar-width: none; }

  .solution-card {
    width: min(560px, 86vw);
    flex: 0 0 auto;
    scroll-snap-align: center;

    transform: scale(0.86);
    opacity: 0.55;
  }

  .solution-card.active {
    transform: scale(1) translateY(-6px);
    opacity: 1;
  }

  .solution-icon {
    width: 100%;
    height: 220px;
  }
  

  .solution-icon img {
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .solution-card:hover .solution-icon img {
    transform: translateX(-50%) translateY(-4px) !important;
  }

  .controls {
    margin-top: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    position: relative;
    z-index: 10;
  }

  .nav-btn {
    width: 44px;
    height: 44px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
  }

  .dots {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
  }

  .dot {
    width: 9px;
    height: 9px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.28);
    cursor: pointer;
  }

  .dot.active {
    background: rgba(255, 255, 255, 0.95);
    transform: scale(1.15);
  }
}
@media (max-width: 420px) {
  .solutions-grid {
    padding-left: calc((100vw - min(560px, 86vw)) / 2);
    padding-right: calc((100vw - min(560px, 86vw)) / 2);
  }

  .solution-card { width: 88vw; }
  .solution-icon { height: 190px; }
}

@media (prefers-reduced-motion: reduce) {
  .solution-card,
  .solution-icon img,
  .btn-acceder {
    transition: none;
    animation: none;
  }
}
</style>
